function addWaterMarker(str, parent_node, font, text_color) {
	// 水印文字，父元素，字体，文字颜色
	var can = document.createElement('canvas');
	parent_node.appendChild(can);
	can.width = 250;
	can.height = 150;
	can.style.display = 'none';
	var cans = can.getContext('2d');
	cans.rotate(-15 * Math.PI / 180);
	cans.font = font || "16px Microsoft JhengHei";
	cans.fillStyle = text_color || "rgba(180, 180, 180, 0.2)";
	cans.textAlign = 'left';
	cans.textBaseline = 'Middle';
	cans.fillText(str, can.width / can.width, can.height / 2);
	parent_node.style.backgroundImage = "url(" + can.toDataURL("image/png") + ")";
	parent_node.style.width = '100%';
	parent_node.style.height = '100%';
	parent_node.style.position = 'absolute';
	parent_node.style.top = '0';
	parent_node.style.left = '0';
	parent_node.style.zIndex = '100000';
	parent_node.style.pointerEvents = 'none';
}
const watermark = {
	bind: function (el, binding) {
		addWaterMarker(binding.value.text, el, binding.value.font, binding.value.text_color);
	}
}
export default watermark;
